// app/javascript/controllers/admin_dashboard_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["notificationButton","notificationPanel","profileButton","profileDropdown","mobileSidebar","tabGroup"]
  static values  = { activeKey: String, navKeys: Array }

  async connect() {
    this.closeAll()
    document.addEventListener("click", this.handleClickOutside, true)

    // init active tab
    const metaActive = document.querySelector('meta[name="active-tab"]')?.content || this.activeKeyValue || "dashboard"
    const keys       = this.navKeysValue || []
    const index      = Math.max(0, keys.indexOf(metaActive))

    if (window.customElements?.whenDefined) await customElements.whenDefined('el-tab-group')
    this.tabGroupTargets.forEach(el => el?.setActiveTab?.(index))
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside, true)
  }

  // ✅ Fired by data-action on each button
  onTabClick(event) {
    const btn  = event.currentTarget
    const href = btn.dataset.navHref
    const key  = btn.dataset.tabKey
    if (!href) return

    const keys = this.navKeysValue || []

    if (href === "#") {
      // In-page panel (e.g. messages)
      event.preventDefault()
      const i = Math.max(0, keys.indexOf(key))
      this.tabGroupTargets.forEach(el => el?.setActiveTab?.(i))
      this.syncAriaSelected(i)
      return
    }

    // Route-backed tab
    event.preventDefault()
    if (window.Turbo?.visit) {
      Turbo.visit(href)
    } else {
      window.location.assign(href)
    }
  }

  // Keep SSR highlight + Tailwind aria-variants in sync
  syncAriaSelected(activeIndex) {
    this.tabGroupTargets.forEach(group => {
      const buttons = group?.querySelectorAll('[data-tab-key]') || []
      buttons.forEach((b, i) => b.setAttribute('aria-selected', (i === activeIndex).toString()))
    })
  }

  // --- existing code unchanged below ---
  openSidebar()  { if (this.hasMobileSidebarTarget) this.mobileSidebarTarget.classList.remove("hidden") }
  closeSidebar() { if (this.hasMobileSidebarTarget) this.mobileSidebarTarget.classList.add("hidden") }
  toggleNotifications() {
    if (!this.hasNotificationPanelTarget) return
    this.notificationPanelTarget.classList.toggle("hidden")
  }
  toggleProfileDropdown() { this.profileDropdownTarget.classList.toggle("hidden") }
  closeAll() {
    if (this.hasNotificationPanelTarget) this.notificationPanelTarget.classList.add("hidden")
    if (this.hasProfileDropdownTarget)   this.profileDropdownTarget.classList.add("hidden")
  }
  handleClickOutside = (event) => {
    if (this.hasNotificationPanelTarget &&
        !this.notificationPanelTarget.classList.contains("hidden") &&
        !this.notificationPanelTarget.contains(event.target) &&
        this.hasNotificationButtonTarget &&
        !this.notificationButtonTarget.contains(event.target)) {
      this.notificationPanelTarget.classList.add("hidden")
    }
    if (this.hasProfileDropdownTarget &&
        !this.profileDropdownTarget.classList.contains("hidden") &&
        !this.profileDropdownTarget.contains(event.target) &&
        this.hasProfileButtonTarget &&
        !this.profileButtonTarget.contains(event.target)) {
      this.profileDropdownTarget.classList.add("hidden")
    }
  }
}
